export const ROLE_COTIZADOR_ADMIN = "ROLE_COTIZADOR_ADMIN";
export const ROLE_COTIZADOR_USER = "ROLE_COTIZADOR_USUARIO";
export const ROLE_COTIZADOR_EJECUTIVO = "ROLE_COTIZADOR_EJECUTIVO";
export const ROLES_COTIZADOR = [ROLE_COTIZADOR_ADMIN, ROLE_COTIZADOR_EJECUTIVO, ROLE_COTIZADOR_USER];

export const ROLE_COTIZADOR_VAM_ADMIN = "ROLE_COTIZADOR_VAM_ADMIN";
export const ROLE_COTIZADOR_VAM_EJECUTIVO = "ROLE_COTIZADOR_VAM_EJECUTIVO";
export const ROLE_COTIZADOR_VAM_USUARIO = "ROLE_COTIZADOR_VAM_USUARIO";
export const ROLES_COTIZADOR_VAM = [ROLE_COTIZADOR_VAM_ADMIN, ROLE_COTIZADOR_VAM_EJECUTIVO, ROLE_COTIZADOR_VAM_USUARIO];
